<nx-default-box-v2
  [label]="'Formular'">
  
  <!-- content -->
  <ng-container [ngTemplateOutlet]="editMode ? editTemplate : displayTemplate"></ng-container>
  
  <!-- actions -->
  <ng-template nxTemplate="mainEnd">
    <ng-container [ngTemplateOutlet]="editMode ? editActionsTemplate : displayActionsTemplate"></ng-container>
  </ng-template>
</nx-default-box-v2>

<!-- content view mode -->
<ng-template #displayTemplate>
  <div class="flex items-center space-x-2">
    <span>{{selectedControl.value?.label}}</span>
  </div>
</ng-template>

<!-- content edit mode -->
<ng-template #editTemplate>
  <div class="mt-1" [formGroup]="form">
    <nx-edit-select-input
      [formGroup]="form"
      #selectComponent  
      [showLabel]="false"
      [panelWidhtFull]="true"
      formControlName="selected"  
      [options]="options"
      [placeholder]="'placeholder'"
      [label]="'label'">
      <ng-template nxTemplate="selectedItem" let-value>
        <div class="flex items-center space-x-2">
          <span class="">{{value?.label}}</span>
        </div>
      </ng-template>
      <ng-template nxTemplate="item" let-item>
        <div class="flex items-center space-x-2">
          <span class="">{{item?.label}}</span>
        </div>
      </ng-template>
    </nx-edit-select-input>
  </div>
</ng-template>

<ng-template #displayActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    (click)="edit()"
    [icon]="'icon-edit'"
    [tooltip]="'Bearbeiten'">
  </nx-default-button>
</ng-template>

<ng-template #editActionsTemplate>
  <nx-default-button
    [style]="'dark'"
    class="mr-1"
    (click)="save()"
    [icon]="'icon-data-import'"
    [tooltip]="'Speichern'">
  </nx-default-button>
  <nx-default-button
    [style]="'dark'"
    (click)="cancel()"
    [icon]="'icon-cancel'"
    [tooltip]="'Abbrechen'">
  </nx-default-button>
</ng-template>
